var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { useEffect, useState } from 'react';
import api from "../../../../../utils/api";
import { useRevalidator } from 'react-router-dom';
import { useSetAtom } from 'jotai';

import { RequestParams } from "../../../../../utils/RequestParams";

import { notificationAtom } from "../../../../atoms";

import { Button, Card, CopyValueInput, Sidepanel } from "../../../../Components/UI";
import { Translate } from "../../../../../I18N";
import loadable from '@loadable/component';
import { InputField } from "../../../../Components/Forms";

const QRCodeSVG = loadable(
  async () => import( /* webpackChunkName: "qrcode.react" */'qrcode.react'),
  {
    resolveComponent: (components) => components.QRCodeSVG
  }
);






const TwoFactorSetup = ({ closePanel, isOpen }) => {
  const [token, setToken] = useState('');
  const [_secret, setSecret] = useState('');
  const [_otpauth, setOtpauth] = useState('');
  const setNotifications = useSetAtom(notificationAtom);
  const revalidator = useRevalidator();
  const [tokenError, setTokenError] = useState(false);

  useEffect(() => {
    if (isOpen && !_secret) {
      api.
      post('auth2fa-secret').
      then((resp) => resp.json).
      then(({ otpauth, secret }) => {
        setSecret(secret);
        setOtpauth(otpauth);
      }).
      catch((error) => {
        throw error;
      });
    }
  }, [isOpen, _secret]);

  const tokenChange = (value) => {
    setToken(value);
    if (tokenError) {
      setTokenError(false);
    }
  };

  const enable2fa = async () => {
    try {
      await api.post('auth2fa-enable', new RequestParams({ token }));
      revalidator.revalidate();
      closePanel();
      setNotifications({
        type: 'success',
        text: /*#__PURE__*/_jsx(Translate, {}, void 0, "2FA Enabled")
      });
    } catch (error) {
      if (error.status === 409) {
        setTokenError(true);
      }
      throw error;
    }
  };

  return /*#__PURE__*/(
    _jsx(Sidepanel, {
      title: /*#__PURE__*/_jsx(Translate, { className: "uppercase" }, void 0, "Two-Factor Authentication"),
      isOpen: isOpen,
      closeSidepanelFunction: closePanel,
      size: "large",
      withOverlay: true }, void 0, /*#__PURE__*/

    _jsx(Sidepanel.Body, {}, void 0, /*#__PURE__*/
    _jsx("div", { className: "grid gap-4 sm:grid-cols-3 sm:gap-6" }, void 0, /*#__PURE__*/
    _jsx(Card, { className: "mb-4 sm:col-span-2", title: /*#__PURE__*/_jsx(Translate, {}, void 0, "Using Authenticator") }, void 0, /*#__PURE__*/
    _jsx("ol", { className: "list-decimal list-inside" }, void 0, /*#__PURE__*/
    _jsx("li", { className: "mb-4" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Download a third-party authenticator app from your mobile store."

    ), "\xA0", /*#__PURE__*/

    _jsx("span", { "no-translate": true, className: "italic text-gray-500" }, void 0, "(Google Authenticator, LastPass Authenticator, Microsoft Authenticator, Authy, etc.)"


    )
    ), /*#__PURE__*/
    _jsx("li", { className: "mb-4" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Add an account to the app by scanning the provided QR code with your mobile device or by inserting the provided key."


    )
    )
    ), /*#__PURE__*/
    _jsx("p", {}, void 0, /*#__PURE__*/
    _jsx(Translate, { className: "italic text-gray-500" }, void 0, "Instructions on how to achieve this will vary according to the app used, please refer to the app's documentation."


    )
    )
    ), /*#__PURE__*/
    _jsx(Card, { className: "mb-4 sm:col-span-1", title: /*#__PURE__*/_jsx(Translate, {}, void 0, "QR Code") }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex justify-center" }, void 0, /*#__PURE__*/
    _jsx(QRCodeSVG, {
      value: _otpauth,
      level: "Q",
      includeMargin: false,
      size: 180,
      bgColor: "white",
      fgColor: "black" }
    )
    )
    ), /*#__PURE__*/
    _jsx(Card, { className: "mb-4 sm:col-span-3", title: /*#__PURE__*/_jsx(Translate, {}, void 0, "Secret keys") }, void 0, /*#__PURE__*/
    _jsx(CopyValueInput, {
      value: _secret,
      className: "mb-4 w-full",
      label: /*#__PURE__*/
      React.createElement(React.Fragment, null, /*#__PURE__*/
      _jsx(Translate, { className: "block" }, void 0, "You can also enter this secret key into your Authenticator app."

      ), /*#__PURE__*/
      _jsx(Translate, { className: "block italic text-gray-500" }, void 0, "*please keep this key secret and don't share it."

      )
      ),

      id: "authenticator-secret" }
    ), /*#__PURE__*/
    _jsx(InputField, {
      onChange: (e) => tokenChange(e.target.value),
      id: "authenticator-token",
      label: /*#__PURE__*/
      _jsx(Translate, { className: "font-bold" }, void 0, "Enter the 6-digit verification code generated by your Authenticator app"

      ),

      name: "token",
      autoComplete: "off",
      value: token,
      hasErrors: tokenError }
    ),
    tokenError && /*#__PURE__*/
    _jsx("p", { className: "mt-2 text-sm text-error-600" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "The token does not validate against the secret key")
    )

    )
    )
    ), /*#__PURE__*/
    _jsx(Sidepanel.Footer, { className: "px-4 py-3" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex gap-2 w-full" }, void 0, /*#__PURE__*/
    _jsx(Button, { styling: "light", onClick: closePanel, className: "grow" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Cancel")
    ), /*#__PURE__*/
    _jsx(Button, { className: "grow", disabled: !token, onClick: enable2fa }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Enable")
    )
    )
    )
    ));

};

export { TwoFactorSetup };